import { useCallback } from "react";
import { getLaborsByWorkOrder } from "../../api/Labors";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetLaborLogs() {
  const setWoLaborLog = useWorkOrderStore((state) => state.setWoLaborLog);

  const getLaborLogs = useCallback(
    async (woNumber: string) => {
      const response = await getLaborsByWorkOrder({
        woNumber,
        appName: "Mobile",
        translations: true,
      });
      if (!response.isError) {
        let data = response.data;
        let query = [];
        for (let i = data.length - 1; i >= 0; i--) {
          query.push(data[i]);
        }
        setWoLaborLog(woNumber, query);
      }
      return response;
    },
    [setWoLaborLog]
  );

  return { getLaborLogs };
}
